import { render, staticRenderFns } from "./InfoNotification.vue?vue&type=template&id=7b694af8"
import script from "./InfoNotification.vue?vue&type=script&lang=ts"
export * from "./InfoNotification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports